<template>
  <sj-question :model="page.questions"
               :fixed-ids="page.appendQuestionIds"
               scroll="#main">
    <draggable v-model="draggableQuestions"
               :options="{handle: '.drag-question-button', group: 'questions'}"
               @update="updateSort">
      <transition-group :class="['step-template-questions-group', 'drag-add-placeholder']">
        <div v-for="(question, questionIndex) of draggableQuestions"
                  :key="question.id">
          <step-template-question :question-index="questionIndex"
                                  ref="form"></step-template-question>
        </div>
      </transition-group>
    </draggable>
    <div v-for="(question, questionIndex) of appendQuestions"
         :key="question.id">
      <step-template-question class="margin t20"
                              :question-index="draggableQuestions.length + questionIndex"
                              ref="form"></step-template-question>
    </div>
  </sj-question>
</template>

<script>
import draggable from 'vuedraggable'
import SjQuestion from '@/views/question-editor/packages/sj-question/src/SjQuestion'
import StepTemplateQuestion from '@/views/step-template/components/StepTemplateQuestion'

export default {
  components: {
    draggable,
    StepTemplateQuestion,
    SjQuestion,
  },
  inject: ['page'],
  props: {
    value: Array,
    // disabled: Boolean,
  },
  data () {
    return {}
  },
  computed: {
    appendQuestions () {
      return this.page.questions.filter(question => this.page.appendQuestionIds.includes(question.id))
    },
    // 因为使用了 computed 所以 vuedraggable 必须使用 v-model 绑定数据
    // 主要为数据的更新方式不同，具体原因见官方文档。
    draggableQuestions: {
      get () {
        return _.difference(this.page.questions, this.appendQuestions)
      },
      set (questions) {
        this.page.questions.splice(0, this.page.questions.length, ...questions, ...this.appendQuestions)
      },
    }
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    validate (callback) {
      let isValid = true
      this.page.validateFailQuestionIds = []
      // 验证全部的表单
      this.$refs.form.forEach((form) => {
        form.validate((valid, question) => {
          if (!valid) {
            isValid = false
            this.page.validateFailQuestionIds.push(question.id)
          }
        })
      })
      callback(isValid)
    },
    updateSort ({newIndex}) {
      this.page.sjQuestionItems[newIndex].removeInvalidJump(this.page.questions, newIndex)
    },
    collapse (bool) {
      this.$refs.form.forEach((form) => {
        form.collapse = bool
      })
    }
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
.step-template-questions-group {
  &.drag-add-placeholder:after {
    content: '';
    display: block;
    min-height: 270px;
    background-image: url(../assets/drag-add-placeholder.png);
    background-position: 10px 90px;
    background-repeat: no-repeat no-repeat;
    border: 1px dashed #DCDFE6;
    border-radius: 4px;
  }

  .sortable-ghost {
    display: block;
    list-style: none;
    margin-bottom: 15px;

    button {
      width: 100%;
    }
  }
}
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/step-template/components/StepTemplateQuestions.vue